import api from '../api';

export interface Subevent {
  id: string;
  eventId: string;
  name: string;
  description: string | null;
  location: string | null;
  startTime: string;
  endTime: string;
  capacity: number | null;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface SubeventPayload {
  name: string;
  description?: string | null;
  location?: string | null;
  startTime: string;
  endTime: string;
  capacity?: number | null;
  isActive?: boolean;
}

const basePath = (eventId: string) => `/events/${encodeURIComponent(eventId)}/subevents`;

export const subeventsApi = {
  list: async (eventId: string): Promise<Subevent[]> => {
    const { data } = await api.get(basePath(eventId));
    return data;
  },

  create: async (eventId: string, payload: SubeventPayload): Promise<Subevent> => {
    const { data } = await api.post(basePath(eventId), payload);
    return data;
  },

  update: async (eventId: string, subeventId: string, payload: SubeventPayload): Promise<Subevent> => {
    const { data } = await api.put(`${basePath(eventId)}/${encodeURIComponent(subeventId)}`, payload);
    return data;
  },

  updateStatus: async (eventId: string, subeventId: string, isActive: boolean): Promise<Subevent> => {
    const { data } = await api.patch(`${basePath(eventId)}/${encodeURIComponent(subeventId)}/status`, { isActive });
    return data;
  },
};

